export default {"src":"/_next/static/media/huc.83cf852c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};